// @ts-nocheck
import { settings_set } from "@pdfking/workflow/state/settings"
import user_get from "../constants/user_get"
import register_dom_update from "../navigation/register_dom_update"

function update_user_data(_, event) {
  if (event.detail?.counter) {
    settings_set("user", user_get())
  }
}
register_dom_update({
  after: update_user_data,
})
